/**
 * Car pages talk back form for each sites, bavaria and Hedin
 *
 * @class
 */
class SharedCarPageTalkbackForm {
  /**
   * Form element is placed here
   * @type {(HTMLElement|null)}
   * @private
   */
  #formElement = null;

  /**
   * Error message element
   * @type {(HTMLElement|null)}
   * @private
   */
  #errorMessageElement = null;

  /**
   * Success message element
   * @type {(HTMLElement|null)}
   * @private
   */
  #successMessageElement = null;

  /**
   * Constructor of SharedCarPageTalkbackForm
   *
   * @param {HTMLElement} formElement - Talkback form element
   */
  constructor(formElement) {
    this.#formElement = formElement;

    this.#errorMessageElement = this.#formElement.querySelector('#talk-back-error-message');

    this.#successMessageElement = document.getElementById('talk-back-success');

    // Bind form send listener
    this.#formElement.addEventListener('submit', this.#formSubmitEvent.bind(this));
  }

  /**
   * Form submit event listener
   * @param {Event} event event object
   *
   * @returns {undefined}
   * @private
   * @async
   */
  #formSubmitEvent(event) {
    event.preventDefault();

    const dataToSend = {
      phoneNumber: this.#formElement['talk-back-phonenumber'].value,
      location: this.#formElement.location.value,
      category: this.#formElement.category.value,
      cmtoken: this.#formElement.cmtoken.value,
      license: this.#formElement.license.value,
    };

    fetch('/stage-ajax/sendTalkBackRequest', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(dataToSend),
    })
      .then((req) => req.json())
      .then(() => {
        this.#showNotification(false);
        this.#formElement.hidden = true;
      })
      .catch(() => {
        this.#showNotification(true);
      });
  }

  /**
   * Show or hide error / success message. If error message exists
   * and form successfully posted --> hide error message and show success
   * 
   * @param {boolean} hasError - If has error, show error message instead of success message
   */
  #showNotification(hasError = false) {
    this.#successMessageElement.hidden = hasError;
    this.#errorMessageElement.hidden = !hasError;
  }

  /**
   * Initialize method. Check if DOM contains talk back form
   * 
   * @static
   */
  static init() {
    const formElement = document.getElementById('hedin-carpage-talkback');
    if (formElement) {
      new SharedCarPageTalkbackForm(formElement);
    }
  }
}

export default SharedCarPageTalkbackForm;
